var _path, _rect, _rect2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833984 5.50477C0.833984 4.3199 1.79451 3.35938 2.97937 3.35938H17.0219C18.2068 3.35938 19.1673 4.3199 19.1673 5.50477V17.2069C19.1673 18.3918 18.2068 19.3523 17.0219 19.3523H2.97938C1.79451 19.3523 0.833984 18.3918 0.833984 17.2069V5.50477ZM2.97937 4.52959C2.4408 4.52959 2.0042 4.96619 2.0042 5.50477V8.82037H17.9971V5.50477C17.9971 4.96619 17.5605 4.52959 17.0219 4.52959H2.97937ZM17.9971 9.99058H13.4463V13.5012H17.9971V9.99058ZM17.9971 14.6714H13.4463V18.1821H17.0219C17.5605 18.1821 17.9971 17.7455 17.9971 17.2069V14.6714ZM12.2761 18.1821V14.6714H7.72524V18.1821H12.2761ZM6.55503 18.1821V14.6714H2.0042V17.2069C2.0042 17.7455 2.4408 18.1821 2.97938 18.1821H6.55503ZM2.0042 13.5012H6.55503V9.99058H2.0042V13.5012ZM7.72524 9.99058V13.5012H12.2761V9.99058H7.72524Z",
    fill: "#0061ED"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8301,
    y: 1.59766,
    width: 1.60558,
    height: 4.69565,
    rx: 0.80279,
    fill: "#0061ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.56641,
    y: 1.59766,
    width: 1.60558,
    height: 4.69565,
    rx: 0.80279,
    fill: "#0061ED"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default ForwardRef;